import * as React from "react";
import { useCopy } from "../../containers";

interface IFooterProps {
  copy: {
    content: string;
  };
}
const Footer: React.FC<IFooterProps> = ({ copy: { content } }) => {
  return <div className="footer">{content}</div>;
};

export const FooterContainer: React.FC = props => {
  const copy = useCopy("footer");

  return <Footer {...props} copy={copy} />;
};
